import axios, { ResponseType } from "axios";
import { UrlConstants } from "./ApiConstants";
import { authHeader, filterNullValues, isGenerateUrl, triggerLogout } from "./utils";
import { Notification } from "./../components/notification/notification";

const instance = axios.create({ timeout: 15000 });
const noErrorInstance = axios.create({ timeout: 15000 });

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    if ((error.response && error.response.status === 401) || error.code === 'ERR_NETWORK') {
      localStorage.removeItem("user");
      triggerLogout();
      return Promise.reject('Unauthorized');
      // return; 
    }

    if (error.response.data.errorMessages && error.response.data.errorMessages.length > 0) {
      return Promise.reject(error);
    }

    Notification("error", error.message);
    // Handle other errors here
    return Promise.reject(error);

  }
);


noErrorInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    if ((error.response && error.response.status === 401) || error.code === 'ERR_NETWORK') {

      localStorage.removeItem("user");
      triggerLogout();

      return Promise.reject('Unauthorized');
    }
    // Handle other errors here
    return Promise.reject(error);
  }
);

export const replaceWithCurrentApiVersion = (url: string): string => {
  if (url.includes("{version}")) {
    url = url.replaceAll("{version}", UrlConstants.API_VERSION);
  }
  return url;
};

export async function GetRequest(url: string, responseType: ResponseType = 'json', hideNotification?: boolean) {

  let auth = authHeader();

  const Headers = {
    Authorization: auth.Authorization,
    'Content-type': 'application/json',
  };

  url = replaceWithCurrentApiVersion(url);
  url = UrlConstants.BASE_URL + url;

  const axiosInstance = hideNotification ? noErrorInstance : instance;


  let response = await axiosInstance.get(url, {
    headers: Headers,
    responseType: responseType
  });


  if(response && response.data) {
    const {data} = response
    return data;
  } else {
    throw "401"
  }

  



}

export async function PutRequest(url: string, data: any, moduleCode?: string, extraHeaders: any = { 'Content-Type': 'application/json' }) {


  data = filterNullValues(data);

  const Headers: any = {
    Authorization: authHeader().Authorization,
    ...extraHeaders
  };

  if (moduleCode) {
    Headers.Modulecode = moduleCode;
  }

  url = UrlConstants.BASE_URL + replaceWithCurrentApiVersion(url);
  const axiosInstance = instance;

  let result = axiosInstance.put(url, data, {
    headers: Headers
  });

  return result;

}

export async function PostRequest(url: string, data: any, moduleCode?: string, extraHeaders: any = { 'Content-Type': 'application/json' }) {

  if (extraHeaders['Content-Type'] !== 'multipart/form-data') {
    data = filterNullValues(data);
  }


  const Headers: any = {
    Authorization: authHeader().Authorization,
    ...extraHeaders
  };

  if (moduleCode) {
    Headers.Modulecode = moduleCode;
  }

  url = UrlConstants.BASE_URL + replaceWithCurrentApiVersion(url);

  const axiosInstance = instance;


  let result = axiosInstance.post(url, data, {
    headers: Headers
  });

  return result;
}


export async function DeleteRequest(url: string, moduleCode?: string) {


  const Headers: any = {
    'Content-Type': 'application/json',
    Authorization: authHeader().Authorization,
  };

  if (moduleCode) {
    Headers.Modulecode = moduleCode;
  }

  url = UrlConstants.BASE_URL + replaceWithCurrentApiVersion(url);
  const axiosInstance = instance;


  let result = axiosInstance.delete(url, {
    headers: Headers
  });

  return result;
}

export const downloadCall = (
  method: 'POST' | 'GET' = 'GET',
  url: string,
  filename: string,
  data: any,
  format: 'base64' | 'blob' = 'blob'
) => {

  if (isGenerateUrl(url)) {
    axios.get(`${UrlConstants.BASE_URL}` + replaceWithCurrentApiVersion(url), {
      headers: {
        authorization: `${authHeader().Authorization}`
      }
    }).then((response) => {
      if (response.status === 200) {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = response.data?.downloadUrl;
        a.download = response.data?.fileName; // The name you want to save the file as
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    })

  } else {
    const Headers = {
      'Content-Type': 'application/json',
      Authorization: authHeader().Authorization,
    };

    console.log("Download format :" + format);

    url = replaceWithCurrentApiVersion(url);
    url = UrlConstants.BASE_URL + url;

    axios({
      method: method,
      url: url,
      responseType: 'blob',
      data: data,
      headers: Headers
    })
      .then(function (response) {

        if (format === 'base64') {
          var reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onloadend = function () {
            var base64data: any = reader.result;
            const link = document.createElement('a');
            link.href = base64data;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
          }
        } else {
          // Create a Blob object representing the data.
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          // Create a link element, click it, then remove it.
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }

      });
  }
} 
